var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ffffff;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,2.9A13.1,13.1,0,1,0,29.1,16,13.11,13.11,0,0,0,16,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.92,25.69a.54.54,0,0,1-.21-.05.45.45,0,0,1-.2-.57L15.32,18H11.59a.43.43,0,0,1-.39-.24.44.44,0,0,1,0-.47L18.77,6.5a.45.45,0,0,1,.58-.13.44.44,0,0,1,.2.56L16.65,14h3.76a.45.45,0,0,1,.39.24.47.47,0,0,1,0,.47L13.29,25.5A.44.44,0,0,1,12.92,25.69Zm-.47-8.58H16a.45.45,0,0,1,.37.2.48.48,0,0,1,0,.42l-1.61,4,4.76-6.87H16a.45.45,0,0,1-.37-.2.42.42,0,0,1,0-.42l1.61-3.92Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.a0ef4774860aa3526f26ed16cb9404cd.svg";
export { ForwardRef as ReactComponent };